<template>
  <div >
    <div class="logo">
      <img height="24" width="24" src="../../assets/logo/krishifyLogo.svg" />
      <p class="logoText">KRISHIFY BUSINESS</p>
    </div>
    <v-divider style="opacity: 0.5;"></v-divider>
    <div class="succesDiv">
      <img height="72" width="72" src="../../assets/LandingPage/greeenTick.svg" />
      <p class="succesText">Account Created Successfully!</p>
    </div>
    <div class="bottomText">
        <p>Krishify Business Suite is not available on Smartphone.
             Please login using your desktop or laptop browser to 
             access the application.</p>
            <button class="--weight" v-ripple @click="$store.dispatch('mainStore/logoutUser')">Logout</button>

    </div>
    <div class="bottomButton" @click="gotoHome()">
        <p>Take me back to the website</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "accountCreated",
  data() {
    return {};
  },
  components: {},
  methods: {
    gotoHome(){
          this.$router.push({name:"landingPage"})
        }
  },
};
</script>

<style lang="scss" scoped>
.logo {
  display: flex;
  column-gap: 8px;
  cursor: pointer;
  margin: 22px 0px 22px 0px;
  justify-content: center;
}
.logoText {
  font-family: "Roboto";
  font-weight: 500;
  font-size: 16px;
  color: #3a3f3a;
  margin: 0px;
}
.succesDiv{
    height: 64vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction:column;
}
.succesText{
    color:#343F38;
    font-size:18px;
    font-family: "Roboto";
    font-weight: 500;
    margin-top: 40px;
}
button {
  color: rgb(228, 66, 66);
  background-color: rgb(243, 231, 231);
  padding: 10px;
  border-radius: 4px;
}
.bottomText{
    color:#5F6762;
    font-size:14px;
    font-family: "Roboto";
    font-weight: 400;
    margin: 0px 39px;
    text-align: center;
}
.bottomButton{
    background-color: #F9F9F9;
    text-align: center;
    height: 65px;
    margin-top: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    p{
        color:#37893C;
        margin:0px;
        font-size:14px;
        font-family: "Roboto";
        font-weight: 500;

    }
}
</style>
